var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 2.1626C17.3872 2.1626 20.9695 5.62358 21.1202 10.0157L21.1248 10.2876V14.726L22.6198 18.145C22.6946 18.3161 22.7332 18.5008 22.7332 18.6876C22.7332 19.4354 22.127 20.0417 21.379 20.0417L16.2498 20.0433C16.2498 21.8382 14.7947 23.2933 12.9998 23.2933C11.2689 23.2933 9.85414 21.9403 9.75529 20.2342L9.74929 20.0409L4.63089 20.0417C4.44527 20.0417 4.26163 20.0035 4.09137 19.9296C3.40541 19.6316 3.09086 18.834 3.38882 18.1481L4.87478 14.727V10.2875C4.87543 5.78647 8.50621 2.1626 12.9998 2.1626ZM14.6243 20.0409L11.3748 20.0433C11.3748 20.9408 12.1023 21.6683 12.9998 21.6683C13.8444 21.6683 14.5386 21.0239 14.6173 20.1998L14.6243 20.0409ZM12.9998 3.7876C9.40294 3.7876 6.5003 6.68471 6.49978 10.2876V15.0647L5.0438 18.4167H20.965L19.4998 15.0658L19.4999 10.3015L19.4959 10.0576C19.3755 6.55463 16.5115 3.7876 12.9998 3.7876Z",
    fill: "#D0C9D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.f2610ad1671f77be2f88018344101c61.svg";
export { ForwardRef as ReactComponent };